<template>
  <div class="energy-chart">
    <Chart v-if="chartData" type="bar" :data="chartData" :options="chartOptions" style="width: 100%; height: 500px;" :plugins="[ChartDataLabels]"/>
    <Skeleton v-else class="" width="100%" height="500px" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ApplianceService from '../../service/ApplianceService';
import 'chartjs-adapter-moment';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { createCustomTooltipHandler } from './tooltipHandler';

export default {
  components: {
  },
  props: {
    serialNumber: String,
    energyUnit: String,
    labs: Array,
    models: Array,
    period: Number
  },
  data() {
    return {
      msConverter: 1000,
      error: false,
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: false,
          tooltip: {
            enabled: false,
            external: null
          },
          datalabels: {
            anchor: 'end',
            align: 'start',
            color: 'white',
            font: {
              size: '17px',
              weight: '700',
              family: 'Titillium Web, sans-serif'
            },
            // formatter: value => { 
            //   if(!value) {
            //     return '';
            //   } else {
            //     return this.$n(value, 'power');
            //   }
            // }
            formatter: () => ''
          },
          title: {
            display: true,
            text: '', // aggiornato dinamicamente
            align: 'start',
            // position: 'top',
            padding: { bottom: 15 },
            color: 'rgba(128, 145, 162, 1)',
            font: {
              size: 17,
              weight: '700',
              family: 'Titillium Web, sans-serif'    
            }
          }
        },
        scales: {
            x: {
                type: 'time',
                time: {
                    unit: 'day',
                    displayFormats: {
                        day: 'YYYY/MM/DD',
                    },
                },
                ticks: {
                    color: '#495057',
                    font: {
                        size: 15,
                        weight: '500',
                        color: 'rgba(156, 163, 175, 1)',    
                        family: 'Titillium Web, sans-serif'                    
                    },
                    callback: function (value) {
                        return this.$d(new Date(value), 'veryShortNumeric');
                    }.bind(this),
                },
                grid: {
                    display: false,
                },
            },
            y: {
                ticks: {
                  color: '#495057',
                  font: {
                      size: 15,
                      weight: '500',
                      color: 'rgba(156, 163, 175, 1)',  
                      family: 'Titillium Web, sans-serif'                  
                  },
                  callback: function (value) {
                      return this.$n(value, this.energyUnit !== 'kWh' ? 'money' : 'power')
                  }.bind(this),
                },
                grid: {
                    color: 'rgba(192, 195, 198, 0.5)',
                    lineWidth: 2,
                },
                title: {
                  display: false
                }
            },
        },
        
      },
      ChartDataLabels,
    };
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
    }),
  },
  watch: {
    'labs': 'reloadChart',
    'models': 'reloadChart',
    'period': 'reloadChart',
    'energyUnit': 'energyUnitUpdate'
  },
  created() {
    this.applianceService = new ApplianceService();
  },
  mounted() {
    this.chartOptions.plugins.tooltip.external = createCustomTooltipHandler(() => this.energyUnit, this.$d, this.$n);
    this.reloadChart();
  },
  methods: {
    reloadChart() {
      this.chartData = null;
      let startTimestamp = this.$moment().subtract(this.period, 'days').startOf('day').unix() * this.msConverter;
      if(this.serialNumber) {
        this.applianceService.getEnergyChartSingle(this.personaltoken, this.serialNumber, startTimestamp)
          .then((data) => {
            if (data.code == "200") {
              this.chartData = data.body;
              this.enhanceChartData();
            } else {
              console.error(JSON.stringify(data));
              this.error = true;
            }
          })
          .catch(error => {
            console.error("ERROR " + error);
            this.error = true;
          });
      } else {
        this.applianceService.getEnergyChartGlobal(this.personaltoken, startTimestamp, this.labs, this.models)
          .then((data) => {
            if (data.code == "200") {
              this.chartData = data.body;
              this.enhanceChartData();
            } else {
              console.error(JSON.stringify(data));
              this.error = true;
            }
          })
          .catch(error => {
            console.error("ERROR " + error);
            this.error = true;
          });
      }
    },
    enhanceChartData() {
      for(let i = 0; i < this.chartData.datasets.length; i++) {
        this.chartData.datasets[i].backgroundColor = ['rgba(0, 153, 115, 1)'];
        this.chartData.datasets[i].borderColor = ['rgba(0, 153, 115, 1)'];
        this.chartData.datasets[i].borderWidth = 1; 
        this.chartData.datasets[i].borderRadius = {
          topLeft: 10,
          topRight: 10,
        };
      }
      this.energyUnitUpdate();
    },
    energyUnitUpdate() {
      // Index 0 = Euro, Index 1 = kWh
      const isMoney = this.energyUnit !== 'kWh';
      this.chartData.datasets[0].hidden = !isMoney;
      this.chartData.datasets[1].hidden = isMoney;
      // this.chartOptions.scales.y.title.text = isMoney ? '€' : 'kWh';
      this.chartOptions.plugins.title.text = this.energyUnit;
    },
  }
};
</script>

<style scoped></style>